import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const IssueConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="issue" />;
};
